import { render } from "./Menus.vue?vue&type=template&id=557be682&scoped=true"
import script from "./Menus.vue?vue&type=script&lang=js"
export * from "./Menus.vue?vue&type=script&lang=js"

import "./Menus.vue?vue&type=style&index=0&id=557be682&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-557be682"

export default script